import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { EnvContext } from "../context/EnvContext";
import { useFirestore } from "../firebase/FirestoreContext";
import { collection, getDocs } from "firebase/firestore";
import config from "../config";
import { borderRadius, fontSize, fontWeight, textAlign } from "@mui/system";

const COA = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.categoriesContainer}>
      <div style={{ fontSize: "1.1rem", fontWeight: 600, marginBottom: 10, display: "flex" }}>
        Certificate of Analysis
        <img src="/images/svg/coa_icon.svg" alt="Certificate of Analysis" style={{ width: 20, height: 20, marginLeft: 5 }} />
      </div>
      <div>This product is tested by third-party labs to ensure it meets federal legal and health standards.</div>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div
          onClick={() => navigate("/legal/certificates-of-analysis")}
          style={{ ...styles.button }}
        >
          See Certificate of Analysis
        </div>
      </div>
    </div>
  );
};

const styles = {
  categoriesContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "15px 10px",
    background: "black",
    borderRadius: 10,
    color: "white",
    fontWeight: 500,
    fontSize: "1rem",
  },
  categoryInlineItem: {
    cursor: "pointer",
    textAlign: "center",
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "column",
    width: "80px",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    width: "100%",
    padding: "10px 10px",
    border: "2px solid white",
    borderRadius: 200,
    textAlign: "center",
    margin: "30px 0 0 0",
    fontWeight: 600,
    cursor: "pointer",
    maxWidth: 550,
  },
};

export default COA;
